import React, {useState} from "react";
import {Table, Button,} from "react-bootstrap";
import {makeStyles, TablePagination} from "@material-ui/core";
import {BiSort, BiSortUp, BiSortDown} from "react-icons/bi";

const useStyles = makeStyles({
    tableHead: {
        opacity: "0.8",
        userSelect: "none",
        cursor: "pointer",
        "&:hover": {
            opacity: "unset",
        }
    },
    tableHeadSelected: {
        opacity: "1",
        userSelect: "none",
        cursor: "pointer"
    },
    tableHeadInner: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },
});

export const Icon = ({sortField, orderBy, fieldName}) => {
    if (sortField === fieldName && orderBy) {
        return <BiSortUp/>
    } else if (sortField === fieldName && !orderBy) {
        return <BiSortDown/>
    } else {
        return <BiSort/>
    }
};

const tableHeadList = [
    {
        id: "agentNumber",
        label: "Agent Code"
    },
    {
        id: "agentName",
        label: "Agent Full Name"
    },
    {
        id: "remainingDebit",
        label: "Debit"
    },
    {
        id: "remainingCredit",
        label: "Credit"
    },
    {
        id: "agentStatus",
        label: "Agent Status"
    },
];

export default function ReportsTable({data, orderBy, setOrderBy, sortField, setSortField, getExcel, take, setTake, setSkip}) {
    const [page, setPage] = useState(0);

    const classes = useStyles();

    function handleSort(fieldName) {
        const order = fieldName === sortField && !orderBy
        setSortField(fieldName);
        setOrderBy(order);
    }

    function handleChangePage(e, page) {
        setPage(page);
        const tempSkip = page > 0 ? page * take : 0;
        setSkip(tempSkip)
    }

    return (
        <>
            <Table striped bordered hover>
                <thead>
                <tr>
                    {tableHeadList.map(({id, label}) => (
                        <th key={id} onClick={() => handleSort(id)}
                            className={sortField === id ? classes.tableHeadSelected : classes.tableHead}>
                            <div className={classes.tableHeadInner}>
                                {label}
                                <Icon
                                    sortField={sortField}
                                    fieldName={id}
                                    orderBy={orderBy}
                                />
                            </div>
                        </th>
                    ))}
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>Total</td>
                    <td></td>
                    <td>{data?.remainingDebitTotal}</td>
                    <td>{data?.remainingCreditTotal}</td>
                    <td></td>
                </tr>
                {data?.totalRemainingDebitCredits?.map(agent => (
                    <tr key={agent?.id}>
                        <td>{agent?.agentNumber}</td>
                        <td>{agent?.agentName}</td>
                        <td>{agent?.remainingDebit}</td>
                        <td>{agent?.remainingCredit}</td>
                        <td>{agent?.agentStatus}</td>
                    </tr>
                ))}

                </tbody>
                <tfoot>
                <tr>
                    <th>Agent Code</th>
                    <th>Agent Full Name</th>
                    <th>Debt</th>
                    <th>Credit</th>
                    <th>Agent Status</th>
                </tr>
                <tr>
                    <TablePagination
                        count={data?.count}
                        page={page}
                        rowsPerPage={take}
                        onChangeRowsPerPage={(e) => setTake(e.target.value)}
                        onChangePage={handleChangePage}
                    />
                </tr>
                </tfoot>
            </Table>
        </>
    )
}